export * from '@primeuix/themes/nora/confirmpopup';
export { default } from '@primeuix/themes/nora/confirmpopup';
